import { Route } from '@angular/router';
import { AppUrls } from '../../../../common/dto/app-urls';
import { LoggedInRouteGuard, NoCompanyRouteGuard, ValidatedEmailRouteGuard } from '../common/routing/route-guards/session-check.guard';

export const CompanyRoute: Route = {
  path: AppUrls.Company.relativeUrl,
  children: [
    {
      path: AppUrls.Company._.Create.relativeUrl,
      loadComponent: () => import('./company-create/company-create.component').then(_ => _.CompanyCreateComponent),
      canActivate: [
        NoCompanyRouteGuard,
      ],
    },
    {
      path: AppUrls.Company._.Join.relativeUrl,
      loadComponent: () => import('./company-join/company-join.component').then(_ => _.CompanyJoinComponent),
    },
    {
      path: '**',
      redirectTo: AppUrls.Company._.Join.relativeUrl,
    },
  ],
  canActivate: [
    LoggedInRouteGuard,
    ValidatedEmailRouteGuard,
  ],
};
